// Source: https://developers.google.com/web/updates/2015/08/using-requestidlecallback#checking_for_requestidlecallback
if (typeof window !== 'undefined' && 'requestIdleCallback' in window === false) {
  window.requestIdleCallback = function (cb) {
    const start = Date.now()
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining() {
          return Math.max(0, 50 - (Date.now() - start))
        },
      })
    }, 1)
  }
}
